module.exports = __webpack_public_path__ + "static/media/stofferingen-27.70d5b7a4.jpg";